import ListingPage from '../../components/ListingPage';
import TemplatesCards from '../../components/Templates/templatesCards';

const TemplatesPage = () => {
  return (
    <ListingPage entityType="template" filterBy="name" Cards={TemplatesCards} createRestrictionKey="layoutsCreate" />
  );
};

export default TemplatesPage;
